import React, { useState, useRef } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Button, Typography, Dialog } from '@material-ui/core';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import CustomForm from '../../Form';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  mainContainer: {
    height: '100%',
    paddingLeft: 16,
    paddingTop: 20,
    paddingBottom: 13,
    backgroundColor: theme.palette.background.default
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    fontWeight: theme.typography.fontWeightRegular
  },
  appBar: {
    position: 'relative'
  },
  title: {
    color: '#FFFFFF'
  },
  btn: {
    width: '100%',
    height: 46
  },
  btnItemGrid: {
    paddingRight: 16,
    paddingTop: 16,
    paddingBottom: 13
  }
}));

const ScreenWithDialog = (props) => {
  const { config, onSubmit, setTemplateId } = props;

  const flowTemplates = config.flows.filter(template => template.type === 'file' && template.visible);

  const classes = useStyles();
  const submitFormButtonsRefCollection = useRef(
    flowTemplates.map(() => React.createRef())
  );
  const formRef = useRef(flowTemplates.map(() => React.createRef()));

  const [open, setOpen] = useState(true);
  const [selected, setSelected] = useState(null);

  const history = useHistory();
  const { t } = useTranslation();

  const handleClose = () => {
    setOpen(false);
    history.push('/file');
  };

  return (
    <Dialog fullScreen open={open}>
      <AppBar className={classes.appBar}>
        <Toolbar>
          <IconButton
            edge='start'
            onClick={() => handleClose()}
            aria-label='close'
          >
            <CloseIcon style={{ color: 'white' }} />
          </IconButton>
          <Typography variant='h6' className={classes.title}>
            {t('createFlowWithDialog:newSignFlow')}
          </Typography>
        </Toolbar>
      </AppBar>
      <Grid
        container
        direction='row'
        justify='space-between'
        className={classes.mainContainer}
      >
        <Grid container>
          <Grid item xs={12}>
            <Typography variant='h6' style={{ paddingBottom: 20 }}>
              {t('createFlowWithDialog:selectFlowType')}
            </Typography>
          </Grid>
          <Grid container>
            {flowTemplates.map((template, index) => {
              return (
                <Grid item xs={12} key={index}>
                  <ExpansionPanel
                    expanded={selected === index}
                    square
                    onChange={(event, expanded) => {
                      if (expanded) {
                        setTemplateId(template.templateId);
                        setSelected(index);
                      } else {
                        setTemplateId(null);
                        setSelected(null);
                      }
                    }}
                    style={{
                      backgroundColor: classes.mainContainer.backgroundColor,
                      border: 'none'
                    }}
                  >
                    <ExpansionPanelSummary
                      expandIcon={<ExpandMoreIcon />}
                      aria-controls={`panel${index}-content`}
                      id={`panel${index}-content`}
                      style={{
                        border: 'none'
                      }}
                    >
                      <Typography className={classes.heading}>
                        {template.name}
                      </Typography>
                    </ExpansionPanelSummary>
                    <ExpansionPanelDetails>
                      <CustomForm
                        formRef={formRef.current[index]}
                        submitFormButton={
                          submitFormButtonsRefCollection.current[index]
                        }
                        schema={template.schema}
                        uiSchema={template.uischema}
                        onSubmit={(form) => {
                          onSubmit(form.formData);
                        }}
                      />
                    </ExpansionPanelDetails>
                  </ExpansionPanel>
                </Grid>
              );
            })}
          </Grid>
        </Grid>
        <Grid container style={{ backgroundColor: classes.mainContainer.backgroundColor }}>
          <Grid item xs={12} className={classes.btnItemGrid}>
            <Button
              className={classes.btn}
              color='primary'
              type='submit'
              variant='contained'
              onClick={() => {
                submitFormButtonsRefCollection
                  .current[selected]
                  .current.click();
              }}
            >
              {t('createFlowWithDialog:save')}
            </Button>
          </Grid>
        </Grid>
      </Grid>
    </Dialog>
  );
};

export default ScreenWithDialog;
